import { normalizedQueryValue } from "./read_state.js";

export function normalizedPathname(urlObj) {
  if (!urlObj) {
    return "";
  }
  const path = String(urlObj.pathname || "").trim();
  if (!path || path === "/") {
    return "/";
  }
  return path.replace(/\/+$/, "") || "/";
}

export function shouldResetViewportForNavigation(currentURL, nextURL) {
  if (!currentURL || !nextURL) {
    return false;
  }

  if (normalizedPathname(currentURL) !== normalizedPathname(nextURL)) {
    return true;
  }

  const currentFeed = normalizedQueryValue(currentURL, "feed");
  const currentSection = normalizedQueryValue(currentURL, "section");
  const nextFeed = normalizedQueryValue(nextURL, "feed");
  const nextSection = normalizedQueryValue(nextURL, "section");
  return currentFeed !== nextFeed || currentSection !== nextSection;
}

export function currentBrowserPathWithQuery() {
  return window.location.pathname + window.location.search;
}

export function syncNextInputForForm(form) {
  if (!(form instanceof HTMLFormElement)) {
    return;
  }
  const nextInput = form.querySelector("input[name='next']");
  if (!(nextInput instanceof HTMLInputElement)) {
    return;
  }
  nextInput.value = currentBrowserPathWithQuery();
}

export function syncNextInputForElement(element) {
  if (!(element instanceof Element)) {
    return;
  }
  const form = element.closest("form");
  syncNextInputForForm(form);
}
